"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.set = set;
exports.clear = clear;
exports.listenToChange = listenToChange;

var _store = _interopRequireDefault(require("store"));

var _events = _interopRequireDefault(require("store/plugins/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_store["default"].addPlugin(_events["default"]);

var CREDENTIALS_KEY = 'credentials';
/**
 * Get credentials from storage
 *
 * @return {Credentials|null}
 */

function get() {
  return _store["default"].get(CREDENTIALS_KEY) || {
    auth: false,
    token: ''
  };
}
/**
 * Directly store a set of credentials in local storage. ** CAUTION ** Only call this with a
 * valid credentials object to prevent issues with auth
 *
 * @param {Credentials} credentials
 *
 * @return {void}
 */


function set(credentials) {
  _store["default"].set(CREDENTIALS_KEY, credentials);
}
/**
 * Clear any stored credentials from storage
 *
 * @return {void}
 */


function clear() {
  _store["default"].remove(CREDENTIALS_KEY);
}
/**
 * Subscribe to credentials changes in storage. Will call the callback
 * on any change
 *
 * @param {func} callback
 *
 * @return {void}
 */


function listenToChange(callback) {
  _store["default"].watch(CREDENTIALS_KEY, callback);
}